// Increase the default height of the nav item
export const navItemTheme = {
  defaultProps: {
    size: 'md',
  },
}
